import React, { useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    TextField,
    FormControlLabel,
    Switch,
} from "@mui/material";
import { generateNewlyAddedUsers } from "../../../../../api/apiCall";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAuth } from "../../../../../auth/auth";

const GenerateNewUsers = ({ week, year }: any) => {
    const { state } = useAuth();
    const [loading, setLoading] = useState(false);
    const [isDateRange, setIsDateRange] = useState(false);

    const { register, handleSubmit, watch, setValue } = useForm<any>({
        defaultValues: {
            week: week,
            year: year,
            startDate: "",
            endDate: "",
        },
    });

    const watchFields = watch();

    const onSubmit = async (data: any) => {
        setLoading(true);

        let formattedData: any

        if (isDateRange) {
            formattedData = {
                startDate: data?.startDate,
                endDate: data?.endDate
            };
        } else {
            formattedData = {
                week: data?.week,
                year: data?.year
            };
        }

        const response = await generateNewlyAddedUsers(state.user?.token, formattedData);
        if (response?.status === 200) {
            toast.success("Report generated successfully!");
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong!");
        }
    };

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsDateRange(event.target.checked);
        if (event.target.checked) {
            setValue("week", week);
            setValue("year", year);
        } else {
            setValue("startDate", "");
            setValue("endDate", "");
        }
    };

    const today = new Date().toISOString().split('T')[0];

    return (
        <>
            <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr" }} gap={3}>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isDateRange}
                                onChange={handleToggle}
                                color="primary"
                            />
                        }
                        label={isDateRange ? "Date Range" : "Week/Year"}
                    />
                </div>

                {!isDateRange && (
                    <>
                        <TextField
                            variant="outlined"
                            label="Week"
                            size="small"
                            type="number"
                            placeholder="Enter Week"
                            fullWidth
                            {...register("week")}
                        />
                        <TextField
                            variant="outlined"
                            label="Year"
                            size="small"
                            type="number"
                            placeholder="Enter Year"
                            fullWidth
                            {...register("year")}
                        />
                    </>
                )}

                {isDateRange && (
                    <>
                        <TextField
                            variant="outlined"
                            label="Start Date"
                            type="date"
                            size="small"
                            fullWidth
                            {...register("startDate", { required: isDateRange })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                max: watchFields.endDate || today
                            }}
                        />
                        <TextField
                            variant="outlined"
                            label="End Date"
                            type="date"
                            size="small"
                            fullWidth
                            {...register("endDate", { required: isDateRange })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                min: watchFields.startDate,
                                max: today
                            }}
                        />
                    </>
                )}

                <Button
                    fullWidth
                    variant="contained"
                    disabled={
                        loading ||
                        (isDateRange ? (!watchFields.startDate || !watchFields.endDate) : (!watchFields.week || !watchFields.year))
                    }
                    style={{
                        boxShadow: "none",
                        backgroundColor: "#1976d2",
                        color: "white",
                    }}
                    onClick={handleSubmit(onSubmit)}
                >
                    {loading ?
                        <CircularProgress size={25} style={{ color: "white" }} />
                        :
                        "Export Report"
                    }
                </Button>
                <div
                    style={{ textAlign: "center", margin: 4, marginBottom: -10 }}
                >
                    {loading && "This might take a while"}
                </div>
            </Box>
        </>
    );
};

export default GenerateNewUsers;
